export const DEFAULT_PROFILEIMAGE_URL =
  "https://sprint-fe-project.s3.ap-northeast-2.amazonaws.com/taskify/profile_image/4-14_3071_1724388135936.jpeg";
